module.exports = __webpack_public_path__ + "img/banner1.c6799d4f.png";